import { baseQuery } from '../baseQuery';

type SendEmailParams = {
  taskId: number;
  message: string;
  subject: string;
  email: string;
  name?: string;
  cc?: string[];
  bcc?: string[];
};

export const putTaskSendEmail = async ({ taskId, message, subject, email, cc, bcc, name }: SendEmailParams) => {
  const data = await baseQuery('task/email', {
    type: 'PUT',
    body: {
      task_ID: taskId,
      message,
      subject,
      email,
      ...(name && { name }),
      ...(cc && { email_to_cc: cc.join(',') }),
      ...(bcc && { email_to_bcc: bcc.join(',') }),
    },
  });

  return data;
};
